import * as ngeohash from "ngeohash";

// Single source of truth for precision rules — shared with the backend.
// Edit only `infra/contracts/geohash-precision.json`.
import contract from "../../../../infra/contracts/geohash-precision.json";

export type Precision = 5 | 6 | 7;

export type LatLng = { lat: number; lng: number };

const PRECISION_BY_ZOOM: ReadonlyArray<{ max_zoom: number; precision: number }> =
  contract.precision_by_zoom;

export function precisionForZoom(zoom: number): Precision {
  for (const { max_zoom, precision } of PRECISION_BY_ZOOM) {
    if (zoom <= max_zoom) return precision as Precision;
  }
  return PRECISION_BY_ZOOM[PRECISION_BY_ZOOM.length - 1].precision as Precision;
}

export function cellsForViewport(center: LatLng, zoom: number): string[] {
  const precision = precisionForZoom(zoom);
  const center_cell = ngeohash.encode(center.lat, center.lng, precision);
  const neighbors = ngeohash.neighbors(center_cell);
  return [center_cell, ...neighbors];
}

export type CellDiff = { added: string[]; removed: string[] };

export function diff(prev: string[], next: string[]): CellDiff {
  const prevSet = new Set(prev);
  const nextSet = new Set(next);
  return {
    added: next.filter((c) => !prevSet.has(c)),
    removed: prev.filter((c) => !nextSet.has(c)),
  };
}
